module.exports = __webpack_public_path__ + "img/dp_lp_pc_counter_bg.0f38e26b.jpg";